"use client";

import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { motion } from 'framer-motion';
import { Mail, Phone, Clock, Instagram } from 'lucide-react';
import { ContactCard } from '@/components/ContactCard';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export default function ContactClient() {
    return (
        <div className="flex flex-col min-h-screen bg-background">
            <Header />
            <main className="flex-grow pt-32 pb-24">
                <div className="container mx-auto px-6 max-w-5xl">
                    <motion.div
                        initial={{ opacity: 1, y: 0 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <div className="text-center md:text-left mb-16">
                            <Badge variant="secondary" className="mb-6 px-4 py-1.5 text-[10px] uppercase tracking-[0.3em] font-black">
                                Get in touch
                            </Badge>
                            <h1 className="font-headline text-5xl md:text-7xl font-black text-foreground mb-12 tracking-tight">
                                Contact <span className="text-primary italic font-normal">Bay Valley Pups</span>
                            </h1>
                        </div>

                        <div className="grid md:grid-cols-2 gap-12 mt-20">
                            <div className="space-y-8">
                                <Card className="bg-card shadow-soft border-none rounded-[2.5rem] overflow-hidden">
                                    <CardContent className="p-8 flex items-center gap-6">
                                        <div className="w-14 h-14 bg-secondary/50 rounded-2xl flex items-center justify-center text-primary shrink-0">
                                            <Phone className="w-7 h-7" />
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-black uppercase tracking-widest text-muted-foreground mb-1">Text or Call</p>
                                            <div className="flex flex-col gap-1">
                                                <a href="tel:4086386236" className="text-lg font-bold text-foreground hover:text-primary transition-colors">(408) 638-6236 (Bay Area)</a>
                                                <a href="tel:5302482677" className="text-lg font-bold text-foreground hover:text-primary transition-colors">(530) 248-2677 (Roseville)</a>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>

                                <Card className="bg-card shadow-soft border-none rounded-[2.5rem] overflow-hidden">
                                    <CardContent className="p-8 flex items-center gap-6">
                                        <div className="w-14 h-14 bg-secondary/50 rounded-2xl flex items-center justify-center text-primary shrink-0">
                                            <Clock className="w-7 h-7" />
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-black uppercase tracking-widest text-muted-foreground mb-1">Hours</p>
                                            <p className="text-lg font-bold text-foreground">By appointment</p>
                                        </div>
                                    </CardContent>
                                </Card>

                                <Card className="bg-secondary/20 shadow-none border-none rounded-[2.5rem] overflow-hidden">
                                    <CardContent className="p-8 flex items-center gap-6">
                                        <div className="w-14 h-14 bg-background/50 rounded-2xl flex items-center justify-center text-primary shrink-0">
                                            <Instagram className="w-7 h-7" />
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-black uppercase tracking-widest text-muted-foreground mb-1">Socials</p>
                                            <p className="text-lg font-bold text-foreground">@bayvalleylittlecompanions</p>
                                        </div>
                                    </CardContent>
                                </Card>
                            </div>

                            <ContactCard>
                                <div className="border-t border-border/50 pt-8 mt-8 text-center space-y-6">
                                    <div>
                                        <h3 className="text-lg font-bold text-foreground mb-2">Visit Guidelines</h3>
                                        <p className="text-sm text-muted-foreground leading-relaxed">
                                            For the health and safety of our puppies (who may not be fully vaccinated) and our family privacy, visits are strictly by appointment only for approved applicants. We ask that you do not visit other kennels or dog parks on the same day before visiting us to prevent the spread of parvo.
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-bold text-foreground mb-2">Response Time</h3>
                                        <p className="text-sm text-muted-foreground leading-relaxed">
                                            We are a busy family-run program, but we do our best to respond to texts and emails within 24 hours. If you haven't heard from us, please feel free to follow up!
                                        </p>
                                    </div>
                                    <p className="text-sm font-bold text-primary bg-primary/5 py-4 px-6 rounded-xl inline-block w-full">
                                        Safety note: For everyone’s safety, visits are scheduled by appointment after initial contact.
                                    </p>
                                </div>
                            </ContactCard>
                        </div>
                    </motion.div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
